import { Stack, IconButton, Typography } from '@mui/material';
import dayjs from 'dayjs';

type MonthSelectorProps = {
  selectedMonth: Date;
  onMonthChange: (month: Date) => void;
};

const MonthSelector = ({ selectedMonth, onMonthChange }: MonthSelectorProps) => (
  <Stack direction="row" spacing={0.5} alignItems="center">
    <IconButton
      onClick={() => {
        const newMonth = dayjs(selectedMonth).subtract(1, 'month').toDate();
        onMonthChange(newMonth);
      }}
      color="error"
      size="small"
    >
      ←
    </IconButton>
    <Typography variant="h6" sx={{ minWidth: '120px', textAlign: 'center' }}>
      {dayjs(selectedMonth).format('MMMM YYYY')}
    </Typography>
    <IconButton
      onClick={() => {
        const newMonth = dayjs(selectedMonth).add(1, 'month').toDate();
        onMonthChange(newMonth);
      }}
      color="error"
      size="small"
    >
      →
    </IconButton>
  </Stack>
);
export default MonthSelector;
